module.exports = __webpack_public_path__ + "static/img/zhong17.112a24c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhong17.png
// module id = rwyy
// module chunks = 16